import IconButton from '@/shared/components/IconButton/IconButton'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import { Autocomplete, Box, TextField } from '@mui/material'
import { useState } from 'react'
import { OptionType } from '@/shared/api/BaseAPI.model'
import { listboxStyles, listElementStyles, popperStyles } from './Select.styles'

interface ArrowSelectProps {
  options: OptionType[]
  onChange: (value: string | string[] | null) => void
  value: string
}

interface HandleIconClickEvent {
  currentTarget: HTMLElement
}

function ArrowSelect({ options, onChange, value }: ArrowSelectProps) {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleIconClick = (event: HandleIconClickEvent) => {
    setAnchorEl(event.currentTarget)
    setOpen(prev => !prev)
  }

  return (
    <Box display="flex" alignItems="center">
      <Autocomplete
        id="color-format-select"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={options.find(option => option.value === value)}
        options={options}
        onChange={(_, newValue) => {
          if (onChange) {
            onChange(newValue?.value)
          }
          setOpen(false)
        }}
        disableClearable
        popupIcon={null}
        renderInput={params => (
          <TextField {...params} sx={{ display: 'none' }} />
        )}
        slotProps={{
          paper: {
            sx: popperStyles
          },
          listbox: {
            sx: listboxStyles
          },
          popper: {
            sx: {
              ...popperStyles,
              width: 'auto !important',
              zIndex: 9999,
              '&.MuiAutocomplete-option': {
                paddingLeft: '8px'
              }
            },
            anchorEl
          }
        }}
        renderOption={(props, option) => (
          <Box component="li" {...props} sx={listElementStyles}>
            {option.label}
          </Box>
        )}
      />
      <IconButton
        icon={<UnfoldMoreIcon />}
        color="primary"
        onClick={handleIconClick}
      />
    </Box>
  )
}

export default ArrowSelect
